export default __webpack_public_path__ + "static/media/show-necklace-1.1bca38ef.webp";